import { RecurringMeetingMapping } from '@/types/RecurringMeetingMapping';
import { queryApi } from '@/utility/queryApi';

export type AddRecurringMeetingAssociationProps = {
  recurringMeetingMapping: RecurringMeetingMapping;
};

export const addRecurringMeetingAssociation = ({
  recurringMeetingMapping,
}: AddRecurringMeetingAssociationProps) =>
  queryApi<RecurringMeetingMapping>({
    body: JSON.stringify(recurringMeetingMapping),
    method: 'POST',
    path: '/api/recurring-meeting-association',
  });
